export const formatPrice = (price) => {
    const roundedPrice = Math.round(price)
    return roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}